import { render, staticRenderFns } from "./MyPatternResults.vue?vue&type=template&id=2f2d61e0&scoped=true&"
import script from "./MyPatternResults.vue?vue&type=script&lang=js&"
export * from "./MyPatternResults.vue?vue&type=script&lang=js&"
import style0 from "./MyPatternResults.vue?vue&type=style&index=0&id=2f2d61e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2d61e0",
  null
  
)

export default component.exports